import { FC } from "react";
import { Route, Switch } from "react-router-dom";

import * as routes from "routes";

import AddRoyaltyAccountContainer from "./components/AddRoyaltyAccountContainer";
import AddRoyaltyAccountSuccess from "./components/AddRoyaltyAccountSuccess";
import ConnectRoyaltyPayorAccount from "./components/ConnectRoyaltyPayorAccount";
import CredentialSubmissionDetails from "./components/ConnectRoyaltyPayorAccount/components/CredentialSubmissionDetails";
import OtherSourceSubmission from "./components/OtherSourceSubmission";
import SearchRoyaltyPayors from "./components/SearchRoyaltyPayors";
import * as addRoyaltyAccountRoutes from "./routes";

const AddRoyaltyAccount: FC = () => {
  return (
    <Switch>
      <Route exact path={routes.sellerAddRoyaltyAccount()}>
        <AddRoyaltyAccountContainer>
          <SearchRoyaltyPayors />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route
        exact
        path={addRoyaltyAccountRoutes.connectGetValuationRoyaltyPayorAccount()}
      >
        <AddRoyaltyAccountContainer>
          <ConnectRoyaltyPayorAccount />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route
        exact
        path={addRoyaltyAccountRoutes.connectGetCredentialsRoyaltyPayorAccount()}
      >
        <AddRoyaltyAccountContainer>
          <ConnectRoyaltyPayorAccount />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route
        exact
        path={addRoyaltyAccountRoutes.connectGetCredentialsRoyaltyPayorAccountDetails()}
      >
        <AddRoyaltyAccountContainer>
          <CredentialSubmissionDetails />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route
        exact
        path={addRoyaltyAccountRoutes.connectGetValuationRoyaltyPayorAccountSuccess()}
      >
        <AddRoyaltyAccountContainer>
          <AddRoyaltyAccountSuccess />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route
        exact
        path={addRoyaltyAccountRoutes.connectGetCredentialsRoyaltyPayorAccountSuccess()}
      >
        <AddRoyaltyAccountContainer>
          <AddRoyaltyAccountSuccess />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route exact path={addRoyaltyAccountRoutes.otherSourceSubmission()}>
        <AddRoyaltyAccountContainer>
          <OtherSourceSubmission />
        </AddRoyaltyAccountContainer>
      </Route>
      <Route
        exact
        path={addRoyaltyAccountRoutes.otherSourceSubmissionSuccess()}
      >
        <AddRoyaltyAccountContainer>
          <AddRoyaltyAccountSuccess />
        </AddRoyaltyAccountContainer>
      </Route>
    </Switch>
  );
};

export default AddRoyaltyAccount;
